import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import UnreadThreadsQuery from '../../components/Dashboard/getUnreadThreads.graphql';
import GetThreadQuery from '../../components/ViewMessage/GetThreadQuery.graphql';
import UnreadCountQuery from '../../components/Inbox/UnreadCount.graphql';

const getUnreadThreadsQuery = () => {
    return async (dispatch, getState, { client }) => {
        await client.query({
            query: UnreadThreadsQuery,
            fetchPolicy: 'network-only'
        });
    }
}

const getUnreadThreadsCountQuery = () => {
    return async (dispatch, getState, { client }) => {
        await client.query({
            query: UnreadCountQuery,
            fetchPolicy: 'network-only'
        });
    }
}

const getAllThreadsQuery = () => {
    return async (dispatch, getState, { client }) => {
        await dispatch(setLoaderStart('inbox'));
        await dispatch(setLoaderComplete('inbox'));
    }
}

const getThreadQuery = ({ threadId, type }) => {
    return async (dispatch, getState, { client }) => {
        await client.query({
            query: GetThreadQuery,
            variables: { threadType: type, threadId: threadId },
            fetchPolicy: 'network-only'
        });
    }
}

export {
    getUnreadThreadsQuery, getUnreadThreadsCountQuery, getThreadQuery, getAllThreadsQuery
}